import { actions } from 'Data/ReduxViewModels/AssignedValuesTests';
import { useDispatch, useSelector } from 'react-redux';
import { InjectedPropsProvider, withInjectedProps } from '../../../Core/InjectedPropsContext';
import { getAssignedMaximumDryDensityProviderProps } from './providerProps';

let AssignedMaximumDryDensityInjectedPropsProvider = ({ children }) => {
  const dispatch = useDispatch();
  const data = useSelector((s) => s.assignedMaximumDryDensityTests);
  const stateSelector = (state) => state.assignedMaximumDryDensityTests;
  const setValue = (opts) => dispatch(actions.setValue(opts));
  const providerData = {
    data,
    setValue,
    stateSelector,
  };
  return (
    <InjectedPropsProvider
      getProviderProps={(consumerProps, modifiers) =>
        getAssignedMaximumDryDensityProviderProps(consumerProps, providerData, modifiers)
      }
    >
      {children}
    </InjectedPropsProvider>
  );
};

AssignedMaximumDryDensityInjectedPropsProvider = withInjectedProps(AssignedMaximumDryDensityInjectedPropsProvider);

export { AssignedMaximumDryDensityInjectedPropsProvider };
export default AssignedMaximumDryDensityInjectedPropsProvider;
